// ═══════════════════════════════════════════════════════════════
//  tacheSms.js — variables du SMS « tâche attribuée » (lot T4)
//
//  ⚠️ CE FICHIER N'IMPORTE RIEN, ET C'EST VOLONTAIRE — même parti pris que
//  workflow.js et affectation.js. Le helper d'envoi vit dans
//  `src/core/smsService.js`, qui importe `../firebase` par un specifier SANS
//  extension : Node ESM ne le résout pas, donc smsService.js n'est pas
//  chargeable en `node` pur et smsService.test.js RECOPIE ses fonctions.
//  Une troncature recopiée dans un test ne teste rien. Les deux seuls bouts
//  de logique réelle du helper sont donc extraits ici, et smsService.test.js
//  les importe POUR DE VRAI.
//
//  Le modèle `smsTemplates/tache_attribuee` (vérifié en base le 10/09/2026) :
//    "Bonjour {prenom}, une tâche EPJ t'a été attribuée : {titre}.
//     {chantier}À faire dans l'app EPJ. — EPJ"
//  `{chantier}` est collé au texte suivant, sans séparateur : la variable
//  porte donc SA PROPRE ponctuation et SON espace final, ou rien du tout.
//  Le moteur de rendu (`renderSmsTemplate`) ne sait pas faire de conditionnel.
// ═══════════════════════════════════════════════════════════════

// Un titre de tâche est un champ libre : la PWA en accepte trois lignes.
// Au-delà de 80 caractères on paierait 2 ou 3 segments SMS pour du texte que
// le destinataire relira de toute façon dans l'app.
export const TITRE_SMS_MAX = 80;

// Troncature avec « … » (un seul caractère, pas trois points) — le résultat
// ne dépasse JAMAIS TITRE_SMS_MAX, ellipse comprise.
export function tronquerTitreSms(titre, max = TITRE_SMS_MAX) {
  const t = typeof titre === "string" ? titre.trim() : "";
  if (t.length <= max) return t;
  return t.slice(0, max - 1).trimEnd() + "…";
}

// Chaîne DÉJÀ ponctuée ou VIDE, jamais " " ni "undefined" : une tâche sans
// chantier ne doit pas laisser une phrase orpheline dans le SMS.
export function phraseChantierSms(chantierNom) {
  const nom = typeof chantierNom === "string" ? chantierNom.trim() : "";
  return nom ? `Chantier : ${nom}. ` : "";
}

// Les 3 variables du modèle, et rien d'autre.
export function variablesTacheAttribuee({ destinataire, titreTache, chantierNom }) {
  return {
    prenom: destinataire?.prenom || "",
    titre: tronquerTitreSms(titreTache),
    chantier: phraseChantierSms(chantierNom),
  };
}
